export default class AlertProcess {
  constructor(id, name, path, cmdline, user, iconBase64, occID = '') {
    this.id = id;
    this.name = name;
    this.path = path;
    this.cmdline = cmdline;
    this.iconBase64 = iconBase64;
    this.user = user;
    this.occID = occID;

    this.toString = this.toString.bind(this);
    this.toDTO = this.toDTO.bind(this);
    this.deepCopy = this.deepCopy.bind(this);
  }

  static parse(typeObj) {
    let id = typeObj['Id'];
    let name = typeObj['Name'];
    let path = typeObj['Path'];
    let cmdline = typeObj['CmdLine'];
    let user = typeObj['User'];
    let iconBase64 = typeObj['IconBase64'];
    let occID = typeObj['OccID'];

    return new AlertProcess(id, name, path, cmdline, user, iconBase64, occID);
  }

  deepCopy() {
    let retVal = new AlertProcess(this.id, this.name, this.path, this.cmdline, this.user, this.iconBase64, this.occID);

    return retVal;
  }

  toDTO() {}

  toString() {
    return `{ id:${this.id}, name:${this.name} path:${this.path} cmd:${this.cmdline} user:${this.user} }`;
  }
}
